import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package } from "lucide-react";
import { api, inr } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const STATUS_COLOR = {
  confirmed: "bg-[#2F80ED] text-white",
  pending: "bg-black/10 text-black",
  shipped: "bg-[#14B8A6] text-white",
  delivered: "bg-[#34D8A0] text-black",
  cancelled: "bg-red-500 text-white",
};

export default function Orders() {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    api.get("/orders").then(({ data }) => setOrders(data));
  }, []);

  if (orders === null) return <div className="min-h-screen animate-pulse bg-black/5 pt-[68px] lg:pt-[116px]" />;

  return (
    <div className="min-h-screen pt-[68px] lg:pt-[116px]" data-testid="orders-page">
      <div className="mx-auto max-w-[1000px] px-5 py-12 sm:px-8">
        <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl">My Orders</h1>

        {orders.length === 0 ? (
          <div className="mt-16 flex flex-col items-center gap-6 text-center" data-testid="no-orders">
            <Package className="h-12 w-12 text-black/20" />
            <p className="font-display text-xl">No orders yet</p>
            <Link to="/shop" className="rounded-full bg-black px-8 py-3 font-semibold text-white hover:bg-[#2F80ED]">
              Start Shopping
            </Link>
          </div>
        ) : (
          <div className="mt-10 space-y-5">
            {orders.map((o) => (
              <div key={o.id} className="border border-black/10 bg-white p-6" data-testid={`order-${o.id}`}>
                <div className="flex flex-wrap items-center justify-between gap-3 border-b border-black/10 pb-4">
                  <div>
                    <p className="font-mono text-xs uppercase tracking-overline text-black/40">Order</p>
                    <p className="font-mono text-sm font-semibold">#{o.id.slice(0, 8)}</p>
                  </div>
                  <div>
                    <p className="font-mono text-xs uppercase tracking-overline text-black/40">Date</p>
                    <p className="font-mono text-sm">{new Date(o.created_at).toLocaleDateString("en-IN")}</p>
                  </div>
                  <div>
                    <p className="font-mono text-xs uppercase tracking-overline text-black/40">Total</p>
                    <p className="font-mono text-sm font-semibold">{inr(o.total)}</p>
                  </div>
                  <Badge className={`${STATUS_COLOR[o.status] || "bg-black/10"} rounded-full px-4 py-1 font-mono text-[10px] uppercase tracking-overline`}>
                    {o.status}
                  </Badge>
                </div>
                <div className="mt-4 flex flex-wrap gap-4">
                  {o.items.map((it) => (
                    <div key={it.product_id} className="flex items-center gap-3">
                      <div className="h-14 w-12 overflow-hidden bg-[#F3F4F6]">
                        <img src={it.image} alt={it.name} className="h-full w-full object-cover" />
                      </div>
                      <div className="text-sm">
                        <p className="font-medium leading-tight">{it.name}</p>
                        <p className="font-mono text-xs text-black/40">×{it.quantity}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
